import { render, staticRenderFns } from "./dept-edit.vue?vue&type=template&id=7aa0dff9&scoped=true&"
import script from "./dept-edit.vue?vue&type=script&lang=js&"
export * from "./dept-edit.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/i-switch.less?vue&type=style&index=0&id=7aa0dff9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa0dff9",
  null
  
)

component.options.__file = "dept-edit.vue"
export default component.exports